import React from 'react';
import classnames from 'classnames';
import { TabType } from '../App';
import { VideoLibraryTab } from './VideoLibraryTab';
import { TrackingTab } from './TrackingTab';
import { RecorderTab } from './RecorderTab';
import './Tabs.scss';

type props = {
  onSelect: (tab: TabType) => void;
  activeTab: TabType;
};

export const Tabs = (props: props) => {
  const changeTab = (id: TabType) => {
    if (id !== props.activeTab) {
      props.onSelect(id);
    }
  };

  return (
    <nav className={'tabs tabs3'}>
      <ul>
        <RecorderTab activeTab={props.activeTab} onSelect={changeTab} />
        <VideoLibraryTab activeTab={props.activeTab} onSelect={changeTab} />
        <TrackingTab activeTab={props.activeTab} onSelect={changeTab} />
        <li className={classnames('tab-border', `active-tab--${props.activeTab}`)} role="presentation">
          <div className="border"></div>
        </li>
      </ul>
    </nav>
  );
};
